module.exports = __webpack_public_path__ + "static/img/cha.0164dee3.svg";